import axios from 'axios';
import { GetEnvironmentConfig } from "../App.Config";

export const putIncidentAsync = async (incident: any) => {
    try{
        await axios.put(`/api/v1/incident`, incident);
    }
    catch(error){
        throw error;
    }
}

export const putUserProducts = async (userProducts: any) => {
    try{
        await axios.put(`/api/v1/userproduct`, userProducts);
    }
    catch(error){
        throw error;
    }
}